import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  END_SESSION: 'END_SESSION',
  END_SESSION_FAILED: 'END_SESSION_FAILED',
  END_SESSION_SUCCESS: 'END_SESSION_SUCCESS',
};

export const endSession = (QID) => ({
  type: types.END_SESSION,
  payload: {
    QID,
  },
});

export const endSessionSuccess = (question) => ({
  type: types.END_SESSION_SUCCESS,
  payload: {
    question,
  },
});

export const endSessionFailed = (errorMessage) => ({
  type: types.END_SESSION_SUCCESS,
  payload: {
    errorMessage,
  },
});

const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case types.END_SESSION:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case types.END_SESSION_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
      };
    case types.END_SESSION_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
      };
    default:
      return state;
  }
}

export const getLoadingStatus = (state) => state.chat.endSession.loadingStatus;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/endSession.js